export default "__VITE_ASSET__Bh5Ckwv5__"